import React from 'react';
import { InsightNode, InsightLink } from 'types';
import { DragHandle } from 'components/ui';

type InsightPageCardProps = {
    insight: InsightNode;
    insightLinks: InsightLink[];
    onDragHandleMouseDown: (e: React.MouseEvent, id: string) => void;
    onUserTagClick?: (name: string) => void;
    onEditClick?: (insight: InsightNode) => void;
};

function formatInsightDate(iso?: string): string | null {
    if (!iso) return null;
    const d = new Date(iso);
    if (isNaN(d.getTime())) return null;
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export default function InsightPageCard({ insight, insightLinks, onDragHandleMouseDown, onUserTagClick, onEditClick }: InsightPageCardProps) {
    const { id, title, description, sourceUser, cornerColor, sourceUrl, createdAt } = insight;
    const color = cornerColor ?? '#f28c5c';
    const dateLabel = formatInsightDate(createdAt);
    const linkCount = insightLinks.length;

    return (
        <div
            className='insight-page-card'
            onClick={() => onEditClick?.(insight)}
        >
            <span
                className='insight-page-card__corner'
                aria-hidden='true'
                style={{ '--corner-color': color } as React.CSSProperties}
            />
            <DragHandle
                className='insight-page-card__drag-handle'
                onMouseDown={(e) => onDragHandleMouseDown(e, id)}
                onClick={(e) => e.stopPropagation()}
                title='Drag to reorder'
            />
            <div className='insight-page-card__body'>
                <span className='insight-page-card__title'>{title}</span>
                {description && (
                    <p className='insight-page-card__description'>{description}</p>
                )}
                <div className='insight-page-card__meta'>
                    <button
                        className='insight-page-card__user'
                        onClick={(e) => { e.stopPropagation(); onUserTagClick?.(sourceUser.name); }}
                        title={`Filter by ${sourceUser.name}`}
                    >
                        {sourceUser.name}
                    </button>
                    {dateLabel && (
                        <span className='insight-page-card__date'>{dateLabel}</span>
                    )}
                    {sourceUrl && (
                        <a
                            className='insight-page-card__url'
                            href={sourceUrl}
                            target='_blank'
                            rel='noopener noreferrer'
                            onClick={(e) => e.stopPropagation()}
                        >
                            Source ↗
                        </a>
                    )}
                    {linkCount > 0 && (
                        <span className='insight-page-card__link-count'>
                            {linkCount} OST link{linkCount !== 1 ? 's' : ''}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
}
